// extracted by mini-css-extract-plugin
export default {"infoWrap":"Info_infoWrap__PGDb3"};